import { GridCellProps } from '@progress/kendo-react-grid';
import { format } from 'date-fns';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useScanManager from 'src/hooks/useScanManager';

const UploadedOnCell = (props: GridCellProps) => {
  const date = props.dataItem.creationDate;
  const dateTime = new Date(date);
  const formattedDate = format(dateTime, 'MM/dd/yyyy hh:mm a');
  const { handleCellClick } = useScanManager();

  const handleClick = useCallback(() => {
    handleCellClick(props.dataItem.attachId);
  }, [handleCellClick, props.dataItem.attachId]);

  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={false}
      title={props.dataItem.creationDate}
      onClick={handleClick}
    >
      {formattedDate}
    </GridCellBase>
  );
};

export default UploadedOnCell;
